<template>
<div class="nj-input">
    <div class="nj-label">{{ label }}</div>
    <textarea class="nj-textarea" :value="value" :disabled="disabled" :placeholder="placeholder" @input="input($event)" @keyup.enter="enter()"></textarea>
</div>
</template>
<script>
export default {
    name: "InputTextarea",
    props: {
        value: null,
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        input(event) {
            this.$emit(
                "input",
                event.target.value == "" ? null : event.target.value
            )
        },
        enter() {
            this.$emit("enter")
        },
    },
    mounted() { },
}
</script>

<style scoped></style>